import { Table } from "containers/Table";
import { IColum } from "containers/Table/interfaces";
import { Container, Header } from "./style";
import { CustomInput } from "components/CustomInput";
import { FaPen } from "react-icons/fa";
import { IPlanilhaCriarLote } from "../../../../interfaces/IPlanilhaCriarLote";
import { useEffect, useState } from "react";
import { defaultVeiculoEditar } from "../../../../constants/defaultVeiculoEditar";
import { ModalEditarVeiculo } from "../modalEditarVeiculo";
import { ModalCertezaEditarVeiculo } from "../ModalCertezaEditarVeiculo";
import { toastSucesso } from "components/Toast";

interface IListarProps {
  dados: IPlanilhaCriarLote[];
  setDados: (dados: IPlanilhaCriarLote[]) => void;
  setSelectedRows: (rows: any[]) => void;
  clearRows: boolean;
}

export function ListarItensCriarLote({
  dados,
  setDados,
  setSelectedRows,
  clearRows,
}: IListarProps) {
  const [paginaAtual, setPaginaAtual] = useState<number>(1);
  const [itensPorPagina, setItensPorPagina] = useState<number>(30);
  const [totalItens, setTotalItens] = useState<number>(dados.length);
  const [pesquisaItensLote, setPesquisaItenslote] = useState<string>("");
  const [dadosExibir, setDadosExibir] = useState<IPlanilhaCriarLote[]>([]);
  const [veiculoEditar, setVeiculoEditar] =
    useState<IPlanilhaCriarLote>(defaultVeiculoEditar);
  const [showModalEditarVeiculo, setShowModalEditarVeiculo] =
    useState<boolean>(false);
  const [showModalCertezaEditarVeiculo, setShowModalCertezaEditarVeiculo] =
    useState<boolean>(false);

  const handleLimitChange = (limite: number) => {
    setItensPorPagina(limite);
    setPaginaAtual(1);
  };

  const handlePageChange = (pagina: number) => {
    setPaginaAtual(pagina);
  };

  useEffect(() => {
    let dadosFiltrados =
      pesquisaItensLote && pesquisaItensLote.length >= 3
        ? [...dados].filter((item) => {
            const buscarTexto = pesquisaItensLote.toLocaleUpperCase();
            return (
              item.renavam.includes(buscarTexto) ||
              item.placa.includes(buscarTexto) ||
              item.chassi.includes(buscarTexto)
            );
          })
        : [...dados];

    const indiceInicial = (paginaAtual - 1) * itensPorPagina;
    const indiceFinal = indiceInicial + itensPorPagina;

    const dadosPaginados = dadosFiltrados.slice(indiceInicial, indiceFinal);

    setTotalItens(dadosFiltrados.length);
    setDadosExibir(dadosPaginados);
  }, [dados, paginaAtual, itensPorPagina, pesquisaItensLote]);

  const handleEditar = () => {
    const dadosEditar = { ...veiculoEditar };

    setDados(
      [...dados].map((item) => {
        if (item.renavam !== dadosEditar.renavam) return item;

        const itemAtualizado = { ...item };

        Object.entries(dadosEditar).forEach(([param, valor]) => {
          if (valor !== undefined && valor !== null && valor !== "") {
            itemAtualizado[param as keyof IPlanilhaCriarLote] = valor;
          }
        });

        return itemAtualizado;
      }),
    );

    setVeiculoEditar({ ...defaultVeiculoEditar });
    toastSucesso("Alterações salvas");
  };

  const columns: IColum<IPlanilhaCriarLote>[] = [
    {
      name: "Placa",
      selector: ({ placa }: IPlanilhaCriarLote) => placa ?? "-",
    },
    {
      name: "Chassi",
      selector: ({ chassi }: IPlanilhaCriarLote) => chassi ?? "-",
    },
    {
      name: "Renavam",
      selector: ({ renavam }: IPlanilhaCriarLote) => renavam ?? "-",
    },
    {
      name: "UF",
      selector: ({ uf }: IPlanilhaCriarLote) => uf ?? "-",
      width: "90px",
    },
    {
      name: "Ações",
      selector: (veiculo: IPlanilhaCriarLote) => (
        <FaPen
          style={{ cursor: "pointer" }}
          onClick={() => {
            setVeiculoEditar({ ...veiculo });
            setShowModalEditarVeiculo(true);
          }}
        />
      ),
      width: "90px",
    },
  ];

  const onChangePesquisaItensLote = (pesquisa: string) => {
    setPaginaAtual(1);
    setPesquisaItenslote(pesquisa);
  };

  return (
    <>
      <Container>
        <Header>
          <CustomInput
            value={pesquisaItensLote}
            onChange={(event) => onChangePesquisaItensLote(event.target.value)}
            placeholder="Pesquisar veículo"
            style={{ maxWidth: 400, marginBottom: 16 }}
          />
        </Header>
        <Table
          keyField="renavam"
          totalRows={totalItens}
          pagination={true}
          columns={columns}
          data={dadosExibir}
          paginationRowsPerPageOptions={[30, 50, 100, 300]}
          loading={false}
          onChangeRowsPerPage={handleLimitChange}
          onChangePage={handlePageChange}
          noSubHeader
          possuiTooltip={false}
          rowsPerPage={itensPorPagina}
          headerFixo
          selectableRows
          selectableRowsNoSelectAll
          setRowsSelected={setSelectedRows}
          clearSelectedRows={clearRows}
        />
      </Container>
      <ModalEditarVeiculo
        show={showModalEditarVeiculo}
        dados={veiculoEditar}
        setDados={setVeiculoEditar}
        onConfirm={() => {
          setShowModalEditarVeiculo(false);
          setShowModalCertezaEditarVeiculo(true);
        }}
        handleClose={() => {
          setShowModalEditarVeiculo(false);
          setVeiculoEditar({ ...defaultVeiculoEditar });
        }}
      />
      <ModalCertezaEditarVeiculo
        show={showModalCertezaEditarVeiculo}
        handleClose={() => {
          setShowModalCertezaEditarVeiculo(false);
          setVeiculoEditar({ ...defaultVeiculoEditar });
        }}
        onConfirm={handleEditar}
      />
    </>
  );
}
